import React__default from 'react';
import OpenChannelUI from './OpenChannel/components/OpenChannelUI.js';
import { O as OpenChannelProvider } from './OpenChannelProvider-abc4ab98.js';
import './OpenChannel/components/OpenChannelInput.js';
import './LocalizationContext-b021af8f.js';
import './stringSet-91746bf1.js';
import './index-353f13f3.js';
import './ui/MessageInput.js';
import './_rollupPluginBabelHelpers-8e4fae98.js';
import 'stream';
import 'prop-types';
import './const-09c22c50.js';
import './const-3f63e129.js';
import './ui/IconButton.js';
import './index-41a6f4f2.js';
import './index-a611bd38.js';
import './ui/MentionUserLabel.js';
import './ui/Icon.js';
import './index-ad4c9e58.js';
import './tslib.es6-83aa13f5.js';
import './OpenChannel/components/FrozenChannelNotification.js';
import './OpenChannel/components/OpenChannelHeader.js';
import './ui/Avatar.js';
import './ui/ImageRenderer.js';
import './uuid-6d14d007.js';
import './index-303a3b6e.js';
import './ui/Loader.js';
import './OpenChannel/components/OpenChannelMessageList.js';
import './index-f119413c.js';
import './index-4a59a866.js';
import './OpenChannel/components/OpenChannelMessage.js';
import './ui/OpenchannelUserMessage.js';
import './ui/ContextMenu.js';
import 'react-dom';
import './ui/SortByRow.js';
import './ui/UserProfile.js';
import './withSendBird.js';
import './sendBirdSelectors.js';
import './topics-17d99dd6.js';
import './UserProfileContext-daa99f9b.js';
import './utils-5395ff17.js';
import './openChannelUtils-024b797a.js';
import './ui/OpenChannelAdminMessage.js';
import './ui/OpenchannelOGMessage.js';
import './ui/LinkLabel.js';
import './ui/OpenchannelThumbnailMessage.js';
import './ui/OpenchannelFileMessage.js';
import './ui/TextButton.js';
import './color-2863fbbe.js';
import './ui/DateSeparator.js';
import './ui/FileViewer.js';
import './index-1fd114b0.js';
import './ui/Modal.js';
import './utils-9ef11656.js';
import './useSendbirdStateContext.js';
import './compareIds-48d87cc5.js';

var OpenChannel = function OpenChannel(props) {
  return /*#__PURE__*/React__default.createElement(OpenChannelProvider, {
    channelUrl: props === null || props === void 0 ? void 0 : props.channelUrl,
    useMessageGrouping: props === null || props === void 0 ? void 0 : props.useMessageGrouping,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    messageLimit: props === null || props === void 0 ? void 0 : props.messageLimit,
    onBeforeSendUserMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendUserMessage,
    onBeforeSendFileMessage: props === null || props === void 0 ? void 0 : props.onBeforeSendFileMessage,
    onChatHeaderActionClick: props === null || props === void 0 ? void 0 : props.onChatHeaderActionClick,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderUserProfile
  }, /*#__PURE__*/React__default.createElement(OpenChannelUI, {
    renderMessage: props === null || props === void 0 ? void 0 : props.renderMessage,
    renderHeader: props === null || props === void 0 ? void 0 : props.renderHeader,
    renderInput: props === null || props === void 0 ? void 0 : props.renderInput,
    renderPlaceHolderEmptyList: props === null || props === void 0 ? void 0 : props.renderPlaceHolderEmptyList,
    renderPlaceHolderError: props === null || props === void 0 ? void 0 : props.renderPlaceHolderError,
    renderPlaceHolderLoading: props === null || props === void 0 ? void 0 : props.renderPlaceHolderLoading
  }));
};

export { OpenChannel as default };